export default __webpack_public_path__ + "static/media/Hospital.d336c663.svg";